import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, LandmarkIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
const IMG = 'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/b2debe7f-87d8-437d-ab16-d96a84ea10fb/product-uploads/';
export const PRODUCT_IMAGE = IMG + 'mcp_f973257d-f5be-49d7-a52b-b36fdf576611_1793815785549.png';
export const heroGuarantees = ['Azonnali letöltés', 'Egyszeri fizetés', 'Nincs előfizetés', '7 napos elégedettségi garancia'];
export const stats = [{
  value: '240',
  label: 'oldal a 6 kötetben'
}, {
  value: '6',
  label: 'digitális rajzkötet'
}, {
  value: '8',
  label: 'évfolyam, 1–8. osztály'
}, {
  value: '5',
  label: 'bónusz ajándékba'
}, {
  value: '1',
  label: 'teljes tanítási rendszer'
}];
export const differenceStats = [{
  value: '1–8. osztály',
  label: 'Az anyag alsó és felső tagozatra rendezve'
}, {
  value: '6 digitális kötet',
  label: 'Az éves tanmenettől a szöveges értékelésig'
}, {
  value: 'Nyomtatható PDF',
  label: 'Használd képernyőn, vagy nyomtasd ki az órára'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Eltűnnek a vasárnap estéid',
  text: 'Órákig ülsz a gép előtt, hogy megtervezd a jövő heti rajzórákat – és még mindig nem vagy kész.'
}, {
  title: 'Órákig tartó ötletkeresés',
  text: 'Az internetes ötletek túl könnyűek, túl nehezek, vagy át kell dolgozni őket, mielőtt használhatnád.'
}, {
  title: 'Feladatlapok a nulláról',
  text: 'Utasítás, kép, elrendezés és szintek – ami percekig tartana, abból egy egész este lesz.'
}, {
  title: 'Egy feladat, sokféle osztály',
  text: 'Ugyanannak az órának működnie kell a kicsiknél és a nagyoknál is, és minden alkalommal át kell alakítanod.'
}, {
  title: 'A rendrakásból káosz lesz',
  text: 'Festék, ragasztó és agyag mindenhol, és kicsöngetnek, mire rend lesz a teremben.'
}, {
  title: 'Az értékelés elviszi az estéidet',
  text: 'Szempontok, pontozás és szöveges értékelések – még több munka a tanítás után.'
}];
export const afterItems = ['Éves tanmenet 1–8. osztályra', 'Percre lebontott, kész óravázlatok', '16 kész alkotó projekt', 'Nyomtatható feladatlapok 3 szinten', 'Rajzolás, festés és mintázás lépésről lépésre', 'Művészettörténet magyar és egyetemes alkotókkal', 'Értékelési szempontok, felmérők és megoldókulcs', '100 kész szöveges értékelés', 'Rajzterem-szabályok a nyugodtabb rendrakáshoz'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'A vasárnap a tervezésé',
  text: 'Minden hétvégén időt töltesz azzal, hogy összerakd a következő hét rajzóráit?'
}, {
  icon: FolderSearchIcon,
  title: 'Sosem tudod, melyik feladatot válaszd',
  text: 'Folyton ötleteket keresel, amelyek illenek a gyerekek korához és tudásához?'
}, {
  icon: LightbulbIcon,
  title: 'Világosabb bemutatást szeretnél',
  text: 'Lépésről lépésre haladó bemutatóra és egyszerű szavakra van szükséged egy új technikához?'
}, {
  icon: PencilRulerIcon,
  title: 'Eleged van a nulláról kezdésből',
  text: 'Szeretnéd, ha az óravázlatok, a feladatlapok és a projektek már készen lennének?'
}, {
  icon: ShuffleIcon,
  title: 'Egy feladatnak minden osztályban működnie kell',
  text: 'Szükséged van rá, hogy ugyanaz a projekt működjön alsóban és felsőben is, átírás nélkül?'
}, {
  icon: LayoutGridIcon,
  title: 'A rajzteremnek több rend kell',
  text: 'Gördülékenyebb lenne minden óra, ha lennének szabályok az eszközökre és a rendrakásra?'
}];
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: '1. kötet',
  level: '1–8. o.',
  title: 'Éves tanmenet és 12 kész rajzóra',
  tagline: 'Pontosan tudod, mit tanítasz – egész évben.',
  intro: 'Az első kötetben megkapod az egész tanév tervét és 12 órát, amelyet akár holnap megtarthatsz.',
  items: ['Éves tanmenet 1–2., 3–4. és 5–8. osztályra', 'Az első félév hétről hétre', '12 hetes terv', 'Fejlődési táblázat', 'Rajzterem-szabályok és balesetvédelem', '12 percre lebontott óra', 'Feladatlapok 3 szinten', 'Felmérők és megoldókulcs', 'Értékelési szempontok'],
  outro: 'Kész éves terv órákkal, amelyeket csak megnyitsz, kinyomtatsz és megtartasz.',
  spine: 'bg-pink-600 text-white',
  rule: 'border-white/30'
}, {
  number: '2. kötet',
  level: '1–8. o.',
  title: '16 kész alkotó projekt',
  tagline: 'Projektek, amelyekre a gyerekek büszkék lesznek.',
  intro: 'A második kötetben 16 teljes alkotó projekt vár a legfontosabb technikákkal.',
  items: ['16 teljes projekt', 'Agyag és plasztika', 'Nyomat és kollázs', 'Festés és akvarell', 'Szövés és textil', 'Népművészeti minták', 'Eszközlista 25 tanulóra', 'Lépéskártyák képekkel', 'Kiállítási ötletek'],
  outro: 'Teljes projektek az eszközlistától a kész alkotásig.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: '3. kötet',
  level: '1–8. o.',
  title: 'Rajzolás, festés és mintázás lépésről lépésre',
  tagline: 'Valódi készségek, egy-egy világos lépéssel.',
  intro: 'A harmadik kötet 16 irányított készségen vezet végig, bemutatókkal, amelyeket az osztály előtt követhetsz.',
  items: ['16 irányított készség', 'Ceruza, akvarell, tempera, pasztell', 'Agyag és papírplasztika', 'Bemutató lépések', 'Tanári mondatok', 'Gyakori hibák és javításuk', 'Gyakorlólapok 3 szinten'],
  outro: 'Világos bemutatók és gyakorlólapok a terem minden tanulójának.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: '4. kötet',
  level: '1–8. o.',
  title: 'A vizuális nyelv elemei unalom nélkül',
  tagline: 'Add a gyerekek kezébe a képek nyelvét.',
  intro: 'A negyedik kötet a vizuális nyelv elemeit és a kompozíció elveit rövid, játékos mini-leckékké alakítja.',
  items: ['Pont, vonal, forma, tér, szín, tónus, felület', 'Egyensúly, kontraszt, kiemelés, ritmus', 'Rövid mini-leckék', 'Nyomtatható feladatlapok', 'Kvízek', 'Megoldókulcs'],
  outro: 'A rajz alapjai úgy tanítva, hogy a gyerekek meg is jegyezzék.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: '5. kötet',
  level: '1–8. o.',
  title: 'Művészettörténet és nagy alkotók gyerekeknek',
  tagline: 'Hozd be a nagy alkotókat a rajzterembe.',
  intro: 'Az ötödik kötet 16 korszakot és alkotót mutat be érdekességekkel, beszélgető kérdésekkel és egy-egy kipróbálható alkotó feladattal.',
  items: ['Barlangrajzok, Egyiptom, görög vázák', 'Honfoglalás kori díszítés', 'Leonardo, Hokusai, Monet, Van Gogh', 'Munkácsy Mihály és Szinyei Merse Pál', 'Csontváry és Rippl-Rónai', 'Kandinszkij, Kovács Margit, Vasarely', 'Idővonal és párosító kvíz', 'A hónap alkotója naptár'],
  outro: 'Művészettörténet, amelyet a gyerekek megnéznek, megbeszélnek és ki is próbálnak.',
  spine: 'bg-cyan-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: '6. kötet',
  level: '1–8. o.',
  title: 'Értékelés és 100 kész szöveges értékelés',
  tagline: 'Értékelj igazságosan és gyorsan – és kapd vissza az estéidet.',
  intro: 'A hatodik kötetben minden megvan a rajzmunkák értékeléséhez, osztályozásához és a szöveges visszajelzéshez.',
  items: ['Szempontsorok technikánként', 'Megfigyelési lap', 'Ön- és társértékelés', 'Portfólió-rendszer', 'A/B felmérők', 'Megoldókulcs és átváltás érdemjegyre', '100 kész szöveges értékelés', 'Fogadóórai útmutató'],
  outro: 'Teljes értékelési csomag az első szempontsortól a bizonyítványig.',
  note: 'A szempontsorok és felmérők független tanári segédanyagok, nem hivatalos mérőeszközök.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 digitális kötet 1–8. osztályra',
  text: 'Teljes rajztanítási rendszer, amely egész évben segít tervezni és tanítani. Minden kötet 40 oldal óravázlattal, projekttel, feladatlappal és tantermi tevékenységgel.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Kész óravázlatok',
  text: 'Nincs több üres lap. Percre lebontott tervek, célok és tanári mondatok, hogy gyorsabban indulhass.'
}, {
  icon: FileTextIcon,
  title: 'Nyomtatható feladatlapok',
  text: 'Azonnal kinyomtatható tanulói lapok 3 szinten, hogy minden gyerek bekapcsolódhasson.'
}, {
  icon: ShapesIcon,
  title: 'Alkotó projektek',
  text: 'Festés, agyag, kollázs, nyomat, textil és plasztika eszközlistával és lépésről lépésre képekkel.'
}, {
  icon: LandmarkIcon,
  title: 'Játékos művészettörténet',
  text: 'Magyar és egyetemes alkotók érdekességekkel, beszélgető kérdésekkel és kipróbálható feladattal.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Szempontsorok és megoldókulcs',
  text: 'Kész szempontsorok, felmérők és megoldókulcs az értékeléshez és a visszajelzéshez.'
}, {
  icon: CalendarCheckIcon,
  title: 'Éves tervezés',
  text: 'Éves tanmenet alsó és felső tagozatra, hogy az első héttől rendben legyen a rajzórák rendje.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  { src: IMG + 'mcp_bf934696-c8f3-43ec-a902-fcb61532e2d1_1793816043636.jpg', label: '1. kötet · 1. oldal', title: 'Éves tanmenet és 12 kész rajzóra', text: 'Az 1. kötet borítója 1–8. osztályra: kész óravázlatok, nyomtatható feladatlapok, 3 szint, felmérők megoldókulccsal.' },
  { src: IMG + 'mcp_f08b0867-58e7-4838-aa20-a8620ed523bd_1793816046161.jpg', label: '1. kötet · 5. oldal', title: 'Éves tanmenet – 1–2. osztály', text: 'Havi táblázat szeptembertől júniusig témával, céllal és fő tevékenységgel, az első színkörtől az év végi kiállításig.' },
  { src: IMG + 'mcp_bfea586b-e8a3-41de-b106-4b3c9e63b3b1_1793816048875.jpg', label: '1. kötet · 12. oldal', title: 'Az 1. óra – Az alapszínek', text: '45 perces óra 1. osztálynak céllal, eszközökkel, percre lebontott menettel és tanári mondatokkal.' },
  { src: IMG + 'mcp_6f0ca190-223e-4e25-999e-f577edbefb06_1793816051772.jpg', label: '1. kötet · 13. oldal', title: 'Feladatlap – Színszámtan', text: 'A tanulók két alapszínt kevernek, és kifestik az eredményt, 3 szinten.' },
  { src: IMG + 'mcp_fb263bdf-4906-445d-91df-fb31457907a9_1793816054985.jpg', label: '1. kötet · 15. oldal', title: 'Feladatlap – A színkör', text: '12 részes színkör szóbankkal: kifestés, elnevezés és kiegészítő színpárok 3 szinten.' },
  { src: IMG + 'mcp_e79fb4d2-eac7-4b49-8a0b-9dfc55c74608_1793816057429.jpg', label: '1. kötet · 20. oldal', title: 'Az 5. óra – Világostól a sötétig', text: 'Tónusskála és árnyékolás 3–4. osztálynak, percre lebontva, tanári mondatokkal.' },
  { src: IMG + 'mcp_9bb6df96-e6fa-4b2c-8891-991da141b85d_1793816059914.jpg', label: '1. kötet · 24. oldal', title: 'A 7. óra – Színek és érzelmek', text: 'Kétórás önarckép-projekt 4–5. osztálynak a képnézés négy lépésével.' },
  { src: IMG + 'mcp_f973257d-f5be-49d7-a52b-b36fdf576611_1793816063024.jpg', label: '1. kötet · 39. oldal', title: 'Értékelési szempontok', text: 'Szempontok 4 szinten, konkrét leírással és átváltással érdemjegyre.' }
];
export const pageTypes = ['Éves tanmenet', 'Kész óravázlatok', 'Feladatlapok 3 szinten', 'Felmérők és megoldókulcs'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Ünnepek és jeles napok',
  text: '30 kész rajzóra az év jeles napjaira, szeptembertől a ballagásig.',
  items: ['Október 23. és március 15.', 'Advent, karácsony, farsang', 'Húsvét és anyák napja', 'Éves ünnepnaptár'],
  benefit: 'Minden ünnepre kész ötlet, kapkodás nélkül.'
}, {
  title: '5 perces rajzbemelegítők',
  text: '60 előkészítés nélküli feladat, hogy minden óra figyelemmel induljon.',
  items: ['60 bemelegítő feladat', '6 témakör', 'Csak papír és ceruza kell', 'Kipipálható lista'],
  benefit: 'Tökéletes az óra első öt percére.'
}, {
  title: 'Kapcsolat a szülőkkel',
  text: 'Kész üzenetek e-naplóba és e-mailbe, hogy soha ne a nulláról írj.',
  items: ['40 kész üzenet', 'Dicséret és lemaradás', 'Kiállítás és pályázat', 'Fogadóórai vázlat'],
  benefit: 'Világos, kedves üzenetek percek alatt.'
}, {
  title: 'Vészhelyzeti rajzórák',
  text: '30 óra csak papírral és ceruzával – ha elfogyott a festék, vagy hirtelen kell órát tartani.',
  items: ['30 kész óra', '3 korosztály', '45 percre bontva', 'Könnyítés és nehezítés'],
  benefit: 'Nyugalom azokra a napokra, amikor minden más.'
}, {
  title: 'Rajztanári tervező 2026/27',
  text: 'Nyomtatható tervező a tanévre: naptár, heti tervező, tanmenet és osztályzatnapló.',
  items: ['36 hetes tanévnaptár', 'Heti tervezőlapok', 'Eszközlista és leltár', 'Kiállítás-tervező'],
  benefit: 'Az egész tanév egy helyen, átláthatóan.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Nyisd meg a RAJZ KÉSZ™ csomagot',
  text: 'Töltsd le a rendszert, és nyisd meg a kötetet, amelyre szükséged van.'
}, {
  title: 'Válaszd ki az órát',
  text: 'Keresd meg az évfolyamodhoz illő órát, projektet vagy készséget, és válaszd ki a megfelelő szintet.'
}, {
  title: 'Készülj fel 5 perc alatt',
  text: 'Olvasd át a tervet és a tanári mondatokat, és válaszd ki a szükséges oldalakat.'
}, {
  title: 'Nyomtass és taníts',
  text: 'Nyomtasd ki a tanulói lapokat, vagy használd képernyőn – és lépj be a rajzterembe világos tervvel.'
}];
export const audienceItems = ['1–4. osztályban tanítasz rajzot', 'Felső tagozatban vizuális kultúrát tanítasz', 'Rendszerezni szeretnéd az egész tanévet', 'Eleged van a feladatlapok gyártásából', 'Több évfolyamon is működő projektek kellenek', 'Világos, lépésről lépésre bemutatókat szeretnél', 'Kész szempontsorokat és felmérőket szeretnél', 'Vissza akarod kapni a vasárnap estéidet'];
export const timeValueTasks = ['Ötletkeresés az interneten', 'Feladatlapok készítése', 'Bemutatók megtervezése', 'Feladatok átalakítása évfolyamonként', 'Értékelés és szöveges értékelések írása'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 digitális kötet – 240 oldal',
  detail: 'Tanmenet, projektek, technikák, vizuális nyelv, művészettörténet és értékelés'
}, {
  label: '5 bónusz felár nélkül',
  detail: 'Ünnepek, bemelegítők, szülői üzenetek, vészhelyzeti órák és tervező'
}, {
  label: '1–8. osztályra',
  detail: 'Kész óravázlatok, feladatlapok és megoldókulcs'
}];
export const offerIncludes = ['Azonnali letöltés', 'Megtartható PDF-fájlok', 'Nyomtatható feladatlapok', 'Nem küldünk fizikai terméket'];
export const PRICE = '7 990 Ft';
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Hogyan kapom meg az anyagot?',
  a: 'A RAJZ KÉSZ™ digitális termék. A vásárlás után hozzáférést kapsz a PDF-fájlokhoz, amelyeket letölthetsz és megtarthatsz. Használhatod számítógépen, tableten vagy telefonon, és kinyomtathatod a szükséges oldalakat.'
}, {
  q: 'Magyar iskolákhoz készült?',
  a: 'Igen. Magyar általános iskolai tanítóknak és rajztanároknak készült, a NAT 2020 vizuális kultúra témaköreihez igazítva. Független tanári segédanyag, nem engedélyezett tankönyv.'
}, {
  q: 'Használható 1–8. osztályban?',
  a: 'Igen. A hat kötet alsó és felső tagozatra rendezve tartalmazza az anyagot. Te választod ki az évfolyamhoz és a témához illő részeket.'
}, {
  q: 'Tényleg fel tudok készülni 5 perc alatt?',
  a: 'A RAJZ KÉSZ™ célja, hogy gyorsabb legyen a felkészülés. Megnyitod a kötetet, kiválasztasz egy kész órát vagy projektet, és nagyjából öt perc alatt átolvasod. Ez függhet az órától, az osztálytól és attól, mennyit szeretnél változtatni.'
}, {
  q: 'Elég egy egész tanévre?',
  a: 'A csomagban éves tanmenet, óravázlatok, projektek és tevékenységek vannak, amelyeket egész évben használhatsz, és a saját naptáradhoz igazíthatsz.'
}, {
  q: 'Vannak kész feladatlapok?',
  a: 'Igen. Nyomtatható feladatlapokat és tanulói lapokat tartalmaz utasításokkal, gyakorlással és képes példákkal.'
}, {
  q: 'Van megoldókulcs?',
  a: 'Igen. A rendszer felmérőket, megoldókulcsot és értékelési szempontokat is tartalmaz.'
}, {
  q: 'Használható különböző szintű tanulókkal?',
  a: 'Igen. A feladatlapok és gyakorlólapok 3 szinten készültek, így mindenkinek kiválaszthatod a megfelelőt.'
}, {
  q: 'Mindent ki kell nyomtatnom?',
  a: 'Nem. Te döntöd el, mit nyomtatsz ki, és az anyag egy részét képernyőn is használhatod.'
}, {
  q: 'Benne van az öt bónusz?',
  a: 'Igen. Mind az öt bónusz benne van felár nélkül.'
}, {
  q: 'Ez előfizetés?',
  a: 'Nem. Egyszer fizetsz, és hozzáférsz a digitális anyaghoz. Nincs ismétlődő díj.'
}, {
  q: 'Megtarthatom a fájlokat?',
  a: 'Igen. A PDF-fájlokat letöltheted és megtarthatod a felhasználási feltételek szerint.'
}, {
  q: 'Van garancia?',
  a: 'Igen. A RAJZ KÉSZ™ 7 napos elégedettségi garanciával érkezik. Ha az anyag nem felel meg az elvárásaidnak, a garanciaidőn belül írj nekünk, és visszakérheted az árát a feltételek szerint.'
}];
export const footerLinks = ['Vásárlási feltételek', 'Adatvédelem', 'Visszatérítés', 'Kapcsolat'];
